/**
 * Idempotency-Key uchun UUID generatsiya qiladi.
 * crypto.randomUUID() mavjud bo'lmasa fallback ishlatiladi.
 */
export function idempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback (eski brauzerlar uchun)
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}
